var _circle, _path, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelpCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E7FCE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.333c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25V18c0 .69-.56 1.25-1.25 1.25h-9.394a2.75 2.75 0 00-1.526.462L9.14 21.006a.25.25 0 01-.389-.208v-9.465z",
    stroke: "#3ECF8E",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.667,
    cy: 14.667,
    r: 1.333,
    fill: "#3ECF8E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 14.667,
    r: 1.333,
    fill: "#3ECF8E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.333,
    cy: 14.667,
    fill: "#3ECF8E",
    r: 1.333
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiNFN0ZDRTkiLz4KPHBhdGggZD0iTTguNzUgMTEuMzMzMkM4Ljc1IDEwLjY0MjkgOS4zMDk2NCAxMC4wODMzIDEwIDEwLjA4MzNIMjJDMjIuNjkwNCAxMC4wODMzIDIzLjI1IDEwLjY0MjkgMjMuMjUgMTEuMzMzM1YxNy45OTk5QzIzLjI1IDE4LjY5MDMgMjIuNjkwNCAxOS4yNDk5IDIyIDE5LjI0OTlIMTIuNjA1NkMxMi4wNjI2IDE5LjI0OTkgMTEuNTMxOSAxOS40MTA2IDExLjA4MDEgMTkuNzExOEw5LjEzODY3IDIxLjAwNjFDOC45NzI1NCAyMS4xMTY4IDguNzUgMjAuOTk3NyA4Ljc1IDIwLjc5ODFWMTEuMzMzMloiIHN0cm9rZT0iIzNFQ0Y4RSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPGNpcmNsZSBjeD0iMTIuNjY2NiIgY3k9IjE0LjY2NjYiIHI9IjEuMzMzMzMiIGZpbGw9IiMzRUNGOEUiLz4KPGNpcmNsZSBjeD0iMTYuMDAwMSIgY3k9IjE0LjY2NjYiIHI9IjEuMzMzMzMiIGZpbGw9IiMzRUNGOEUiLz4KPGVsbGlwc2UgY3g9IjE5LjMzMzMiIGN5PSIxNC42NjY2IiByeD0iMS4zMzMzMyIgcnk9IjEuMzMzMzMiIGZpbGw9IiMzRUNGOEUiLz4KPC9zdmc+";
export { SvgHelpCenter as ReactComponent };